import React, { useEffect, useRef } from 'react';
import ChatBotMessage from './ChatBotMessage';
import { ClickAwayListener, Drawer, InputBase, Tooltip } from '@material-ui/core';
import chevronRight from '../common/Images/chevron_right.png';
import send from '../common/Images/send.svg';
import info from '../common/Images/Info.svg';
import deleteIcon from '../common/Images/delete.svg';
import deleteRed from '../common/Images/delete_red.svg';
import { Skeleton } from '@material-ui/lab';

function useScroll() {
    const refToScrollDiv = useRef(null);

    const [scrollTop, setScrollTop] = React.useState(0);
    const [scrollDown, setScrollDown] = React.useState(0);
    const onScroll = (event) => {
        setScrollTop(event.target.scrollTop);
        setScrollDown(event.target.scrollHeight - refToScrollDiv.current.clientHeight - event.target.scrollTop);
    };

    return [scrollTop, scrollDown, refToScrollDiv, { onScroll }];
}

const ChatBot = ({
    open,
    description,
    examples,
    title,
    icon,
    queryPlaceholder,
    messages,
    isAnalyzing,
    onMessageSubmit,
    onMessageReaction,
    onClear,
    onHide,
    onClose,
    disclaimer,
    disclaimerExtraInfo,
    clearText,
    inClearFiltersProcess,
    AcknowledgmentPopover,
    disabled
}) => {
    const [scrollTop, scrollDown, refToScrollDiv, scrollProps] = useScroll();

    const [inputValue, setInputValue] = React.useState('');
    const [focused, setFocused] = React.useState(true);

    useEffect(() => {
        refToScrollDiv.current.scrollTop = refToScrollDiv.current.scrollHeight;
    }, [messages, refToScrollDiv]);

    const onFocus = () => setFocused(true);
    const onBlur = () => setFocused(false);
    const onchangeInputValue = (inputValue) => {
        setInputValue(inputValue);
    };
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            sendMessage();
        }
    };
    const sendMessage = () => {
        onMessageSubmit(inputValue);
        setInputValue('');
    };

    const onClearButton = () => {
        setInputValue('');
        onClear();
    };

    return (
        <div className="overflow-hidden">
            <ClickAwayListener mouseEvent="onMouseDown" onClickAway={onHide}>
                <Drawer
                    variant="persistent"
                    open={open}
                    onClose={onClose}
                    anchor="right"
                    PaperProps={{
                        className: 'w-120 z-[5000]'
                    }}>
                    {AcknowledgmentPopover}
                    <div className="h-16 justify-between font-medium border-gray-200 border-b pt-2 pr-6 pb-2 pl-6 flex items-center">
                        <span className="text-sf-purple-500 justify-between text-base flex">
                            <img src={icon} alt="" className="pr-1" /> {title}
                        </span>
                        <span className="text-sf-light-700 text-sf flex">
                            BETA
                            <button onClick={onHide}>
                                <img src={chevronRight} alt="" className="pl-2" />
                            </button>
                        </span>
                    </div>
                    <div className="flex flex-col h-[calc(100vh-4rem)]">
                        {messages?.length > 0 && (
                            <div>
                                <button
                                    onClick={onClearButton}
                                    className="group float-right items-center text-sf-dark-500 flex border-gray-200 border h-8 text-sf rounded-lg mb-4 mt-4 mr-6  hover:border-[rgba(203,155,152,1)]">
                                    <img src={deleteIcon} alt="" className="pt-2 pb-2 pl-2 pr-1 group-hover:hidden" />
                                    <img
                                        src={deleteRed}
                                        alt=""
                                        className="pt-2 pb-2 pl-2 pr-1 hidden group-hover:block"
                                    />
                                    <span className="pr-3"> {clearText} </span>
                                </button>
                            </div>
                        )}

                        <div
                            ref={refToScrollDiv}
                            {...scrollProps}
                            className={`${scrollTop > 0 ? 'border-t' : ''}
                                ${scrollDown > 0 ? ' border-b' : ''}
                                h-[88%] overflow-y-auto scroll-smooth`}>
                            {(messages === undefined || messages?.length === 0) && (
                                <div>
                                    {inClearFiltersProcess ? (
                                        <div className="h-32 p-6">
                                            <Skeleton variant="text" width="90%" animation="wave" />
                                            <Skeleton variant="text" width="80%" animation="wave" />
                                            <Skeleton variant="text" animation="wave" />
                                            <Skeleton variant="text" width="70%" animation="wave" />
                                        </div>
                                    ) : (
                                        <div className="text-sf-light-700 h-32 p-6 text-sf">{description}</div>
                                    )}

                                    <div className="pl-6 pr-6 pt-2.5 pb-2.5 text-sf-light-700 text-sf">Examples</div>
                                    <div className="mr-6 ml-6">
                                        {inClearFiltersProcess ? (
                                            <div className="h-32">
                                                <div className="h-10">
                                                    <Skeleton variant="text" height={52} width="80%" animation="wave" />
                                                </div>
                                                <div className="h-10">
                                                    <Skeleton variant="text" height={52} animation="wave" />
                                                </div>
                                                <div className="h-10">
                                                    <Skeleton variant="text" height={52} width="90%" animation="wave" />
                                                </div>
                                            </div>
                                        ) : (
                                            examples.map((example, index) => (
                                                <button
                                                    key={index}
                                                    className="text-left text-sf text-sf-dark-500 w-full rounded-lg border mb-2 pr-4 pl-4 pb-2.5 pt-2.5 hover:border-sf-primary-300 hover:duration-300"
                                                    onClick={() => {
                                                        onMessageSubmit(example);
                                                        setInputValue('');
                                                    }}>
                                                    {example}
                                                </button>
                                            ))
                                        )}
                                    </div>
                                </div>
                            )}
                            {messages?.length > 0 && (
                                <div>
                                    <div>
                                        {messages.map((message, index) => (
                                            <ChatBotMessage
                                                key={index}
                                                message={message}
                                                onMessageReaction={onMessageReaction}></ChatBotMessage>
                                        ))}
                                        {isAnalyzing && (
                                            <div className="bg-sf-purple-100 rounded-l-2xl rounded-tr-2xl mr-6 ml-14 pr-4 pl-4 pt-4 pb-4 ">
                                                <div className="animate-pulse bg-gradient-to-r rounded-l-2xl from-sf-purple-400 h-2 "></div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="min-h-22 max-h-40">
                            <div
                                className={`${
                                    focused && !isAnalyzing
                                        ? 'border-sf-purple-300 shadow-[0_0_8px_0_rgba(225,182,253,0.3)]'
                                        : 'border-sf-light-500'
                                } ${
                                    isAnalyzing ? 'bg-sf-light-100' : ''
                                } w-108 flex items-center justify-between border rounded-lg ml-6 mb-1 mt-4 mr-6 pr-3 pl-4 pb-1 pt-1`}>
                                <InputBase
                                    multiline={true}
                                    inputProps={{
                                        maxLength: 400
                                    }}
                                    autoFocus={true}
                                    className="text-sf text-sf-dark-500 overflow-y-auto min-h-10 max-h-20"
                                    placeholder={queryPlaceholder}
                                    value={inputValue}
                                    fullWidth={true}
                                    disabled={disabled}
                                    onChange={(event) => {
                                        onchangeInputValue(event.target.value);
                                    }}
                                    onFocus={onFocus}
                                    onBlur={onBlur}
                                    onKeyDown={handleKeyDown}
                                />
                                {inputValue.length > 0 && (
                                    <button onClick={sendMessage}>
                                        <img src={send} alt="" />
                                    </button>
                                )}
                            </div>
                            <div className="flex text-sf-light-700 text-xxs pl-6 mb-4">
                                <span className="pr-1">{disclaimer}</span>
                                <Tooltip
                                    title={disclaimerExtraInfo}
                                    enterDelay={100}
                                    placement={'top'}
                                    classes={{ tooltip: 'bg-black text-xs h-fix w-64 pb-1.5 pt-1.5 pl-3 pr-3 mb-1' }}>
                                    <span className="flex items-center">
                                        <img src={info} alt="" />
                                    </span>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </Drawer>
            </ClickAwayListener>
        </div>
    );
};

export default ChatBot;
